import { getCurrencySymbol, DEFAULT_CURRENCY } from "./currencies";

export function formatMoney(amount, currencyCode = DEFAULT_CURRENCY) {
  const sym = getCurrencySymbol(currencyCode);
  const n = Number(amount || 0);
  return `${sym}${n.toLocaleString("en-US")}`;
}

export function formatMoneyCompact(amount, currencyCode = DEFAULT_CURRENCY) {
  const sym = getCurrencySymbol(currencyCode);
  const v = Number(amount || 0);
  const abs = Math.abs(v);
  if (abs >= 1_000_000) return `${sym}${(v / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${sym}${(v / 1_000).toFixed(0)}k`;
  return `${sym}${v}`;
}
